import React from 'react';
import { BlockType, WidgetType } from '../../../types/api/ElementType';
import { isEmptyBlock, isNonEmptyBlock } from '../../../types/api/Block';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { DefaultWidgetWithHeader } from '../../../_lib/components/Widget';
import { Widget } from '../../../types/api/Widget';
import { Icons } from '../../../components/atoms/SVG';
import { CurrentAccessLevelBlock } from '../../../_blocks/fib/CurrentAccessLevelBlock';
import { ChangeAccessLevelBlock } from '../../../_blocks/fib/ChangeAccessLevelBlock';

type FibAccessLevelBlocks = CurrentAccessLevelBlock | ChangeAccessLevelBlock;

export type AccessLevelWidget = Widget<FibAccessLevelBlocks[], WidgetType.accesslevel>;

const getBlocks = (block: FibAccessLevelBlocks) => {
  switch (block.elementType) {
    case BlockType.currentAccessLevel:
      return <CurrentAccessLevelBlock key={block.uuid} {...block} />;
    case BlockType.changeAccessLevel:
      return <ChangeAccessLevelBlock key={block.uuid} {...block} />;
    default:
      return null;
  }
};

export function AccessLevelWidget({ blocks, elementType, ...headerProps }: AccessLevelWidget) {
  const { t } = useSonTranslation('AccessLevel');

  if (blocks && blocks.every(block => isEmptyBlock(block))) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.LATEST_REGISTRATIONS}
      title={t('widgetTitle')}
    >
      {blocks.filter(isNonEmptyBlock).map(getBlocks)}
    </DefaultWidgetWithHeader>
  );
}
